import { render, staticRenderFns } from "./ConfigProdutoCaracteristicasAdd.vue?vue&type=template&id=f2d9cee2"
import script from "./ConfigProdutoCaracteristicasAdd.vue?vue&type=script&lang=js"
export * from "./ConfigProdutoCaracteristicasAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports